import { createSelector } from 'reselect'

import CHANNEL_CODES from 'constants/channels'
import { CHANNEL_PAYMENT_FLOWS, CHANNEL_BOOKING_TYPES } from 'constants/payment'

export const getChannels = state => state.channels

export const getChannelsData = createSelector([getChannels], state => (state ? state.data : null))

export const getChannelCurrency = createSelector([getChannels], state =>
  state ? state.data.currency : null
)

export const getChannelsError = createSelector([getChannels], state => (state ? state.error : null))

export const isFetchingChannels = createSelector([getChannels], state =>
  state ? state.isFetching : false
)

export const getChannelPaymentType = createSelector([getChannelsData], data =>
  data ? data.paymentType : null
)

export const getChannelBookingType = createSelector([getChannelsData], data =>
  data ? data.bookingType : null
)

export const isRemotePayment = createSelector(
  [getChannelBookingType],
  bookingType => bookingType === CHANNEL_BOOKING_TYPES.REMOTE
)

export const isDirectPayment = createSelector(
  [getChannelPaymentType],
  paymentType => paymentType === CHANNEL_PAYMENT_FLOWS.DIRECT
)

export const isThirdPartyOnlinePayment = createSelector(
  [getChannelPaymentType],
  paymentType => paymentType === CHANNEL_PAYMENT_FLOWS.THIRD_PARTY
)

export const isThirdPartyOnlineConfirmation = createSelector(
  [getChannelsData],
  data =>
    data &&
    data.paymentType === CHANNEL_PAYMENT_FLOWS.THIRD_PARTY &&
    data.bookingType === CHANNEL_BOOKING_TYPES.DIRECT
)

export const isArgChannel = createSelector(
  [getChannelsData],
  channel => channel && channel.pointOfSaleId === CHANNEL_CODES.WEB_AR
)
